module.exports = __webpack_public_path__ + "img/mongodb.fa8e0a8a.png";